import './util/polyfill';

import App from './App.html';

const initializeApp = () => new App({ target: document.getElementById('widget-apostas') });

initializeApp();
